import { useQuery, UseQueryResult } from 'react-query';
import { getFilters } from '@creditsights/api-ui-web';
import { Filter, FilterType, FilterDto } from '../../models/Filter';

export const QUERY_KEY_FILTERS = 'fetchFilters';

export default (filterTypes: FilterType[]): UseQueryResult<Filter[], Error> => {
  return useQuery<FilterDto[], Error, Filter[]>([QUERY_KEY_FILTERS], getFilters, {
    select(dtos) {
      return filterTypes
        .map((filterType) => dtos.find((dto) => dto.type.toString() === filterType))
        .filter((dto): dto is FilterDto => !!dto)
        .map((filter) => ({ type: FilterType[filter.type.toString()], options: filter.options }));
    },
  });
};
